module.exports = __webpack_public_path__ + "images/dsdea44770c52405aa427dba02265bdc2a.png";